import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ProgressComponent } from './progress/progress.component';
import { MainComponent } from './main/main.component';
import { SharedModule } from '../shared/shared.module';
import { PagesComponent } from './pages.component';
import { PerfilComponent } from './perfil/perfil.component';
//Proceso
import { ProcesoComponent } from './proceso/proceso.component'
import { SimularComponent } from './proceso/simular/simular.component';
import { PagoComponent } from './proceso/pago/pago.component'
import { DocumentosComponent } from './proceso/documentos/documentos.component'
import { BorradorComponent } from './proceso/borrador/borrador.component';
import { AdmisionComponent } from './main/admision/admision.component';
import { SuccessComponent } from './external/success/success.component';
import { FailedComponent } from './external/failed/failed.component';
import { FaseComponent } from './proceso/fase/fase.component';
import { PersonalComponent } from './proceso/personal/personal.component';
import { EducacionComponent } from './proceso/educacion/educacion.component';
import { ContratoComponent } from './proceso/contrato/contrato.component';
import { NumericoPipe } from '../pipes/numerico.pipe';
import { EstadonotaPipe } from '../pipes/estadonota.pipe'
import { DigitOnlyDirective } from '../directives/digit-only.directive'
import { NumberDirective } from '../directives/number-only.directive'
import { MatFormFieldModule  } from '@angular/material/form-field';
import { MatSelectModule  } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { StringFilterByPipe } from '../pipes/stringFilterBy.pipe';
import { BecodeComponent } from './becode/becode.component';
import { NgxLoaderModule } from '@tusharghoshbd/ngx-loader';
import { ContratoecertComponent } from './proceso/contratoecert/contratoecert.component';


@NgModule({
  declarations: [
    MainComponent,
    ProgressComponent,
    PagesComponent,
    PerfilComponent,
    SimularComponent,
    PagoComponent,
    DocumentosComponent,
    BorradorComponent,
    ProcesoComponent,
    AdmisionComponent,
    SuccessComponent,
    FailedComponent,
    FaseComponent,
    PersonalComponent,
    EducacionComponent,
    ContratoComponent,
    NumericoPipe,
    EstadonotaPipe,
    DigitOnlyDirective,
    NumberDirective,
    StringFilterByPipe,
    BecodeComponent,
    ContratoecertComponent
  ], exports: [
    MainComponent,
    ProgressComponent,
    PagesComponent,
    SimularComponent,
    PagoComponent,
    DocumentosComponent,
    BorradorComponent,
    ProcesoComponent,
    DigitOnlyDirective,
    NumberDirective
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule ,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxLoaderModule
   ]
})
export class PagesModule { }
